/*
  This component maps over passed messageHeaders array, pulls out id, subject,
  and length for each header object in the messageHeaders.

  These are the threads that display in the /messages LandingPage ActionsPanel.
  They can be comprised of several messages in one thread.
  See MsgThreadList for where individual messages
  are parsed.
*/

import React, { Component } from 'react';
import { array, func } from 'prop-types';
import moment from 'moment';

import MessageThreadHeaderListItem from '../MessageThreadHeaderListItem';

import s from './MessageThreadHeaderList.css';


export default class MessageThreadHeaderList extends Component {
  static propTypes = {
    messageThreadHeaders: array,
    handleMsgThreadDisplay: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeItem: null,
    };
  }

  onItemActive = (threadId) => {
    this.setState({
      activeItem: threadId,
    });
  };

  /*
    The messageHeaders from the parent LandingPage initially is undefined.
    This has to do with how the call is made and the
    lifecycle of the child > parent relationship.
  */
  render = () => {
    const {
      messageThreadHeaders,
      handleMsgThreadDisplay,
    } = this.props;

    const noMessages = (messageThreadHeaders.length === 0);

    const messageThreadHeaderListItem = messageThreadHeaders.map((msgThreadHeader) => {
      const id = msgThreadHeader.id;
      const subject = msgThreadHeader.subject;
      const threadCount = msgThreadHeader.count;
      const read = msgThreadHeader.read;
      const content = msgThreadHeader.content;

      const convertTime = (date) => moment.unix(date / 1000).format('h:mm A, MMM Do, YYYY');

      return (
        <MessageThreadHeaderListItem
          messageThreadHeaders={messageThreadHeaders}
          key={id}
          id={id}
          subject={subject}
          content={content}
          timestamp={convertTime(msgThreadHeader.time)}
          threadcount={threadCount}
          read={read}
          handleMsgThreadDisplay={handleMsgThreadDisplay}
          onItemActive={this.onItemActive}
          active={id === this.state.activeItem}
        />
      );
    });

    return (
      <section className={s.component}>
        {noMessages ? (
          <p className={s.messagePlaceholder}>
            No messages at this time.
          </p>
        ) : (
          messageThreadHeaderListItem
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadHeaderList/MessageThreadHeaderList.js